import { enableProdMode } from '@angular/core'
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic'

import { AppModule } from './app/app.module'
import { environment } from './environments/environment'
import { Logger } from './app/services/logger.service'

// const oldAlert = alert;

// window.alert = function () {
//   console.log(new Error().stack);
//   oldAlert.apply(window, arguments);
// };

if (environment.production) {
  enableProdMode()
  Logger.enableProductionMode()
}

platformBrowserDynamic().bootstrapModule(AppModule)
  .catch(err => console.error(err))

window.addEventListener('load', () => {
  const style = document.createElement('style');

  style.innerHTML = `
    /* @font-face {
      font-family: NotoSansJP;
      src: url("assets/fonts/NotoSansJP/NotoSansJP-Black.otf") format("opentype");
      font-weight: 800;
      font-display: swap;
    } */

    @font-face {
      font-family: NotoSansJP;
      src: url("assets/fonts/NotoSansJP/NotoSansJP-Bold.otf") format("opentype");
      font-weight: 700;
      font-display: swap;
    }

    @font-face {
      font-family: NotoSansJP;
      src: url("assets/fonts/NotoSansJP/NotoSansJP-Medium.otf") format("opentype");
      font-weight: 500;
      font-display: swap;
    }

    @font-face {
      font-family: NotoSansJP;
      src: url("assets/fonts/NotoSansJP/NotoSansJP-Regular.otf") format("opentype");
      font-weight: 400;
      font-display: swap;
    }

    @font-face {
      font-family: NotoSansJP;
      src: url("assets/fonts/NotoSansJP/NotoSansJP-Light.otf") format("opentype");
      font-weight: 300;
      font-display: swap;
    }

    @font-face {
      font-family: NotoSansJP;
      src: url("assets/fonts/NotoSansJP/NotoSansJP-Thin.otf") format("opentype");
      font-weight: 200;
      font-display: swap;
    }
  `;

  document.head.appendChild(style);
});

const ImageSetter = Image.prototype.__lookupSetter__('src');

Image.prototype.__defineSetter__('src', function (src: string) {
  ImageSetter.bind(this)(src);

  if (src.startsWith('/assets/') || src.startsWith('assets/')) {
    this.setAttribute('crossOrigin', 'anonymous');
  }
})
